import axios from "axios";
import {adapta_notificacion} from "./adapta_notificacion";

export const enviarNotificacion = async ({numero, mensaje}) => {

    let formatoMensaje = adapta_notificacion({numero: numero, mensaje: mensaje});

    let data = JSON.stringify(formatoMensaje);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //  url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/0cd8f263-679b-465d-aa2b-85aed2a04926', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/0cd8f263-679b-465d-aa2b-85aed2a04926',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return axios.request(config)


}